/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Swiper from 'swiper';
import SwiperCore, {Autoplay, EffectFade, Navigation, Pagination,Thumbs} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay,EffectFade,Thumbs]);
window.Swiper = Swiper;
